
export default {
  matchPage: {
    matchID: 'MLB_2020_5_OAK_LAA',
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    }
  },
  gameBar: {
    sports: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    },
    hideLiveProbabilities: true
  },
  sideBar: {
    sports: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    },
    hideLiveProbabilities: true
  },
  matchList: {
    sportCode: 'MLB',
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    hideLiveProbabilities: true
  },
  valueBets: {
    sports: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    }
  },
  liveDashboard: {
    sports: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    }
  },

  // article widgets
  centreHeading: {
    matchID: 'MLB_2020_5_OAK_LAA',
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    }
  },
  centrePreMatch: {
    matchID: 'MLB_2020_5_OAK_LAA',
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    // valueBetsLink: "/quick-picks",
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    }
  },
  centreBestBet: {
    matchID: 'MLB_2020_5_OAK_LAA',
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    }
  },
  futures: {
    sports: ['NFL', 'NBA'],
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    },
    hideLiveProbabilities: true
  },

  futuresMini: {
    sportCode: 'NFL',
    showGamblingInformation: true,
    publicationTheme: 'dimers',
    oddsDisplayFormat: 'american',
    teamDisplayNameDefault: 'nickname',
    teamLogoDefault: 'official',
    terminologyLocale: 'US',
    sportIconSet: 'dimers',
    liveSportsAvailable: ['NBA', 'MLB', 'NHL', 'NFL', 'CFB'],
    applyUserProximityWeighting: true,
    allowShortlisting: false,
    futuresLinkFunction: function (sport) {
      if (!sport) return ''
      return process.env.VUE_APP_WEB_URL + '/futures'
    },
    // valueBetsLink: "/quick-picks",
    bookmakers: [
      'fanduel',
      /* "william-hill", */ 'betmgm',
      /* "sugarhouse", */ 'pointsbet'
    ],
    customBookmakerLinks: {
      betmgm:
        'https://mediaserver.partners.roardigital.com/renderBanner.do?zoneId=1612073',
      // "sugarhouse": "https://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_1885b_675c_&affid=620&siteid=1885&adid=675&c=",
      betrivers:
        'http://wlsugarhouseaffiliates.adsrv.eacdn.com/C.ashx?btag=a_3094b_750c_&affid=940&siteid=3094&adid=750&c=',
      pointsbet:
        'http://join.pointsbet.com/irivalmedia-150?utm_source=Unbounce_iRivalMedia&utm_medium=Digital_Affiliate_CPA&utm_campaign=Dep_Tiered_50_100_150_250_iRivalMedia&utm_term=Unbounce&utm_content=iRivalMedia&promo=DIMERS',
      // "william-hill": "https://wlwilliamhillus.adsrv.eacdn.com/C.ashx?btag=a_335b_3c_&affid=81&siteid=335&adid=3&c=",
      fanduel: 'https://sportsbook.fanduel.com'
    },
    hideLiveProbabilities: true
  }

}
